module.exports = __webpack_public_path__ + "static/media/instagram.e6042529.png";